import React from 'react';
import { CtaButton } from '../ui/CtaButton';
const pills = ['📚 12 capítulos', '📄 +140 páginas', '🇦🇷 Sistema argentino', '📲 PDF digital'];
export function Hero() {
  return <header className="w-full bg-gradient-to-b from-ink-950 via-ink-900 to-pitch" data-id="element-108" data-mp="cvupufilmxsx">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-5 pb-20 pt-4 text-center md:pb-28" style={{
      alignItems: "center",
      justifyContent: "flex-start"
    }} data-id="element-109" data-mp="cy7ch5zaxwcb">
        <span className="inline-block rounded-full bg-brand-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brand-gold ring-1 ring-brand-gold/30" data-id="element-110" data-mp="mtit5tu9tdmp">
          ⚽ Método Fútbol Digital
        </span>
        <h1 className="mt-8 font-display text-4xl font-black leading-[1.08] text-white sm:text-5xl md:text-6xl" data-id="element-111" data-mp="vofbbbvyy0mp">
          Protegé, acompañá y <span className="text-brand-gold" data-id="element-112" data-mp="15l1w60oaoroq">potenciá la carrera</span>{' '}
          futbolística de tu hijo
        </h1>
        <video autoPlay={true} loop={true} muted={true} playsInline={true} disablePictureInPicture={true} controlsList="nodownload nofullscreen noremoteplayback" aria-hidden="true" onContextMenu={e => e.preventDefault()} style={{
        display: 'block',
        margin: '40px auto 8px',
        maxWidth: '260px',
        width: '100%',
        aspectRatio: '1/1',
        objectFit: 'cover',
        borderRadius: '14px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.4)',
        pointerEvents: 'none',
        cursor: 'default',
        userSelect: 'none',
        WebkitUserSelect: 'none'
      }} data-id="element-113" data-mp="1akoa6cby6byl">
          <source src="https://cdn.magicpatterns.com/uploads/c9YDGJgN8wkorSVTFF1rd3/Video%20de%20muestra%20del%20producto%20-%20Trim%202.mp4" type="video/mp4" data-id="element-114" data-mp="sg4ysar872mr" />
        </video>
        <p className="mt-10 max-w-2xl text-base leading-relaxed text-body md:text-lg" style={{
        fontSize: "20px"
      }} data-id="element-115" data-mp="imo6xcanfxlq">
          <strong className="block font-bold text-white text-center" style={{
          fontSize: "20px"
        }} data-id="element-116" data-mp="el2vlvdrjrdn">MÉTODO PARA PADRES DE FUTBOLISTAS</strong>
          Reúne todo lo que necesitás saber sobre el fútbol juvenil argentino en un solo método práctico y completo.
        </p>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-117" data-mp="30mfitw3qxzgr">
          {pills.map(pill => <li key={pill} className="rounded-full border border-ink-border bg-ink-card/70 px-4 py-2 text-sm font-semibold text-body" data-id="element-118" data-mp="35kh3glgtm6uc">
              {pill}
            </li>)}
        </ul>
        <div className="mt-10" data-id="element-119" data-mp="2vtw774omdeel">
          <CtaButton size="xl" data-id="element-120" data-mp="2vt483jvtcyjk">Obtener el método ahora</CtaButton>
        </div>
        <p className="mt-5 text-sm text-subtle" data-id="element-121" data-mp="2htuvsvaqaokv">
          🔒 Pago seguro · ⚡ Acceso inmediato · ✅ Garantía de 7 días
        </p>
      </div>
    </header>;
}